module.exports = __webpack_public_path__ + "img/r_game_images_05.d7920b5d.png";